export const SUBSCRIPTION_FEATURE_KEYS = [
  'models:teams.subscriptions.sharedTeamStorage2TB',
  'models:teams.subscriptions.unLimitedProjectsTasks',
  'models:teams.subscriptions.unLimitedProjectsTasksMembers',
  'models:teams.subscriptions.teamAdminRoles',
  'models:teams.subscriptions.centralizedBilling',
  'models:teams.subscriptions.globalActivityLog',
];
